import { ErrorPage } from '@squareup/dex-feature-shared-main-error-page';
import { HeaderContainer } from '@squareup/dex-feature-shared-main-header-container';
import { Spinner } from '@squareup/dex-icons/dex/misc';
import { Box } from '@squareup/dex-ui-shared-base';
import { useDecision } from '@squareup/dex-ui-shared-feature-detection';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React, { FC, useMemo } from 'react';

import styles from './mobile-payments-page.module.css';

type Platform = 'ios' | 'android';

interface MobilePaymentsPageProps {
  platform: Platform;
}

const staticPath: Record<Platform, string> = {
  ios: 'https://square.github.io/mobile-payments-sdk-ios/docs/documentation/mobilepaymentssdkapi',
  android: 'https://square.github.io/mobile-payments-sdk-android',
};

const platformTitles: Record<Platform, string> = {
  ios: 'Mobile Payments SDK for iOS',
  android: 'Mobile Payments SDK for Android',
};

export const MobilePaymentsPage: FC<MobilePaymentsPageProps> = ({
  platform,
}) => {
  const header = useMemo(() => {
    return (
      <HeaderContainer
        slim={true}
        searchDomain="docs"
        disableHamburgerMenu
        hideSearch
      />
    );
  }, []);

  const {
    decision: { enabled },
    isClientReady,
  } = useDecision('mobile_payments_sdk_docs_enabled');

  return (
    <Box className={styles['layout-wrap']}>
      {header}
      {isClientReady ? (
        <>
          {enabled ? (
            <iframe
              data-testid="legacy-sdk-iframe"
              src={staticPath[platform]}
              className={styles['iframe']}
              title={`${platformTitles[platform]} Documentation`}
              aria-label={`Documentation for ${platformTitles[platform]}`}
            />
          ) : (
            <ErrorPage code={404} />
          )}
        </>
      ) : (
        <Box margin={{ top: '6x' }} className={styles['spinner-container']}>
          <Spinner
            data-testid="loading-spinner"
            className={clsx(
              commonIconStyles['icon-spinner'],
              styles['spinner']
            )}
          />
        </Box>
      )}
    </Box>
  );
};
